import React, { useState, useEffect } from 'react';
import {
  Container,
  ServiceDrawer,
  ThemeButton,
  ThemeTable,
} from '../../components/components';
import { message } from 'antd';
import { add_icon, delete_icon, edit_icon } from '../../assets/icons/icons';
import { SettingFilled } from '@ant-design/icons';
import { uploadImage } from '../../helpers/helpers';
import {
  useCreateServiceMutation,
  useDeleteServiceMutation,
  useGetServicesQuery,
  useUpdateServiceMutation,
} from '../../services/dogServiceApi';

const Service = () => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('create');
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({});
  const [image, setImage] = useState('');
  const { data, refetch } = useGetServicesQuery();

  const [createService] = useCreateServiceMutation();
  const [updateService] = useUpdateServiceMutation();
  const [deleteService] = useDeleteServiceMutation();

  const onClose = () => {
    setFormData({});
    setImage('');
    setOpen(false);
  };

  const onSubmit = async () => {
    setLoader(true);
    const url = await uploadImage(formData?.image);
    let data = { ...formData, image: url };
    let response;
    if (mode === 'create') {
      response = await createService({ service: data });
    } else {
      response = await updateService({
        id: data?._id,
        body: { service: data },
      });
    }
    if (!response?.data?.error) {
      setLoader(false);
      message.success(
        `Service ${mode === 'create' ? 'created' : 'updated'} successfully.`
      );
      onClose();
      refetch();
    } else {
      setLoader(false);
      message.error(response?.data?.msg || 'Please fill form correctly.');
    }
  };

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      render: (data, _, index) => (
        <p className="text-center font-medium">{index + 1}</p>
      ),
    },
    {
      title: 'Banner',
      dataIndex: 'image',
      key: 'image',
      render: (picture, data) => (
        <div className="flex justify-center">
          <img
            className="object-contain"
            src={picture}
            alt=""
            style={{ height: '45px', width: '80px' }}
          />
        </div>
      ),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: text => <p className="text-center font-medium">{text}</p>,
    },
    {
      title: 'Check In',
      dataIndex: 'check_in',
      key: 'check_in',
      render: text => <p className="text-center font-medium">{text}</p>,
    },
    {
      title: 'Check Out',
      dataIndex: 'check_out',
      key: 'check_out',
      render: text => <p className="text-center font-medium">{text}</p>,
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: text => <p className="font-medium text-right">$ {text}</p>,
    },
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',
      render: active => (
        <div className="flex justify-center">
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${
              active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}
          >
            {active ? 'Active' : 'Inactive'}
          </span>
        </div>
      ),
    },
    // {
    //   title: 'In Action',
    //   dataIndex: '_id',
    //   key: '_id',
    //   width: '10%',
    //   render: (text, data) => (
    //     <span className="flex justify-center items-center">
    //       <span className="mx-2 cursor-pointer" onClick={() => onEdit(data)}>
    //         <img src={edit_icon} alt="" width={15} />
    //       </span>
    //       <span
    //         className="mx-2 cursor-pointer"
    //         onClick={() => onDelete(data?._id)}
    //       >
    //         <img src={delete_icon} alt="" width={15} />
    //       </span>
    //     </span>
    //   ),
    // },
  ];

  return (
    <Container
      selected={'2'}
      header={
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div className="bg-primary h-9 w-9 rounded-full flex justify-center items-center">
              <SettingFilled className="text-white" />
            </div>
            <p className="ml-2 font-semibold text-2xl">Services</p>
          </div>

          {/* <ThemeButton
            onClick={() => setOpen(true)}
            className={'ml-3'}
            content={
              <div className="flex items-center">
                <img src={add_icon} alt="" width={18} height={18} />
                <p className="ml-2">Create Service</p>
              </div>
            }
          /> */}
        </div>
      }
    >
      <ThemeTable
        columns={columns}
        data={data?.data || []}
        entityName="services"
        emptyText="No services yet. Add one to make it bookable in the app."
      />

      <ServiceDrawer
        formData={formData}
        image={image}
        setImage={e => setImage(e)}
        setFormData={e => setFormData(e)}
        isLoading={loader}
        onSubmit={onSubmit}
        open={open}
        onClose={onClose}
        btnTxt={mode == 'create' ? 'Create Service' : 'Update Service'}
      />
    </Container>
  );
};

export default Service;
